module.exports = __webpack_public_path__ + "static/scarlet_beebalm_16x20-51071d20f9c19aabd3069bba3938ec3d.jpg";